// extracted by mini-css-extract-plugin
module.exports = {"accordion-colors":"_1z5EV","accordionColors":"_1z5EV"};